<div class="meeting-minute-rows">

  @for (row of controls; track trackRow($index, row); let index = $index) {
    <div class="meeting-minute-row" [formGroup]="row">

      <div class="meeting-minute-row-header">
        <span class="meeting-minute-row-index">Participant {{ index + 1 }}</span>
        @if (!readonlyRows) {
          <button
            type="button"
            class="btn btn-outline-danger btn-icon remove-row-button"
            title="Remove participant"
            (click)="onRemoveRow(index)">
            <i class="fa fa-solid fa-trash"></i>
          </button>
        }
      </div>

      <div class="row">
        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label class="fw-bold meeting-minute-field-label">User</label>
            <select-field
              [selectFormControl]="getControl(row, 'userId')"
              [options]="userOptions">
            </select-field>
          </div>
        </div>

        <div class="col-lg-6 col-md-6">
          <div class="form-group">
            <label class="fw-bold meeting-minute-field-label">Status</label>
            <select-field
              [selectFormControl]="getControl(row, 'status')"
              [options]="statusOptions">
            </select-field>
          </div>
        </div>
      </div>

    </div>
  } @empty {
    <div class="empty-text text-center text-muted py-3">
      @if (readonlyRows) {
        This meeting minute has no participant.
      } @else {
        No participant yet. Use "Add item" to create the first one.
      }
    </div>
  }

  @if (!readonlyRows) {
    <div class="add-row-bar">
      <button type="button" class="btn btn-primary" (click)="onAddRow()">
        <i class="fa fa-plus me-1"></i>Add item
      </button>
    </div>
  }

</div>
